import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './homepage.css'
import noImage from '../../images/no_image.png'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import ProfileBlock from './ProfileBlock.js'
import NormalBlock from './NormalBlock.js'
import ExternalLinkBlock from './ExternalLinkBlock.js'
import TitleBar from '../TitleBar'
import 'react-confirm-alert/src/react-confirm-alert.css'

export default class Homepage extends Component {
  constructor(props) {
    super(props)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    this.state = {
      user: this.getUser(),
      refreshButton: refreshButton
    }
    this.props.setActiveTab('homepage')
    this.refresh = this.refresh.bind(this)
    window.trackPage('HomeScreen')
    this.redirectToEval()
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)
    if(urlParams.get('refresh')) {
      this.refresh()
    }
  }

  redirectToEval() {
    if(localStorage.getItem('event_survey_id')){
      window.location.href = '/event_evaluation/' + localStorage.getItem('event_survey_id')
      localStorage.removeItem('event_survey_id')
    }
  }

  getUser() {
    return _.find(this.props.users.event_users, {user_id: parseInt(this.props.currentUser.user_id, 10)})
  }

  image() {
    if(this.state.user.photo) {
      return <img className='pull-right rounded-circle profile-image rounded-circle' height="80" src={this.state.user.photo} alt='' />
    } else {
      return <img className='pull-right rounded-circle profile-image rounded-circle' height="80" src={noImage} alt='' />
    }
  }

  getMessageAlert() {
    let filterFunction = (message) => !message.has_been_read && message.recipient_user_id === this.props.currentUser.user_id
    let unreadMessages = this.props.messages.messages.filter(filterFunction)
    return unreadMessages.length ? unreadMessages.length : null
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'homepage',
      callback: () => {
        this.props.updateResource({
          key: 'messages',
          callback: () => {
            this.props.updateResource({
              key: 'sessions',
              callback: () => {
                this.setState({
                  refreshButton: '<i class=\'fa fa-refresh\'></i>'
                })
              }
            })
          }
        })
      }
    })
  }

  handleOptIn(url) {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'opt_in_p2p',
      callback: () => {
        this.props.updateResource({
          key: 'homepage',
          callback: () => {
            this.setState({
              refreshButton: '<i class=\'fa fa-refresh\'></i>'
            })
          }
        })
      }
    })
    window.open(url)
  }

  render() {
    const blocks = []
    _.each(this.props.homepage.homepage.homepage_blocks, (homepage_block) => {
      switch(homepage_block.type_key){
      case 'image':
        blocks.push(
          <img
            key={ homepage_block.id }
            src={ homepage_block.image }
            alt='' />
        )
        break
      case 'wifi_sponsor':
        blocks.push(
          <NormalBlock
            homepageBlock={ homepage_block }
            url={ '/sponsor/' + homepage_block.sponsor_id }
            key={ homepage_block.id } />
        )
        break
      case 'p2p_wizard':
        if(homepage_block.p2p_info?.has_peer_to_peer && homepage_block.p2p_info?.registration_status_key === 'registration_status_approved') {
          homepage_block.title = homepage_block.p2p_info?.external_1_on_1_platform_selections_is_complete ? 'Edit Peer-to-Peer Setup' : 'ALERT Complete Peer-to-Peer Setup'
          blocks.push(
            <ExternalLinkBlock
              className={homepage_block.p2p_info?.external_1_on_1_platform_selections_is_complete ? '' : 'solar'}
              homepageBlock={ homepage_block }
              target='_self'
              externalUrl={ `${homepage_block.p2p_info?.external_1_on_1_platform_wizard_url}?wizard_from=web` }
              key={ homepage_block.id } />
          )
        }
        break
      case 'my_profile':
        blocks.push(
          <ProfileBlock
            homepageBlock={ homepage_block }
            profileImage={ this.image() }
            messageCount={ this.getMessageAlert() }
            key={ homepage_block.id }
            currentUser={ this.state.user}/>
        )
        break
      case 'leaderboard':
      case 'notes':
      case 'settings_and_support':
        blocks.push(
          <NormalBlock
            homepageBlock={ homepage_block }
            url={ homepage_block.type_key }
            key={ homepage_block.id } />
        )
        break
      case 'contact_form':
        blocks.push(
          <NormalBlock
            homepageBlock={ homepage_block }
            url={ 'homepage_contact_form' }
            key={ homepage_block.id } />
        )
        break
      case 'custom_page':
        blocks.push(
          <NormalBlock
            homepageBlock={ homepage_block }
            url={ homepage_block.type_key + '/' + homepage_block.id }
            key={ homepage_block.id } />
        )
        break
      case 'url_link':
        blocks.push(
          <ExternalLinkBlock
            homepageBlock={ homepage_block }
            externalUrl={ homepage_block.link_url }
            key={ homepage_block.id } />
        )
        break
      case 'twitter_feed':
        blocks.push(
          <div
            key={ homepage_block.id }>
            { homepage_block.title }
          </div>
        )
        break
      case 'map':
        blocks.push(
          <ExternalLinkBlock
            homepageBlock={ homepage_block }
            externalUrl={ homepage_block.map_pdf_url }
            key={ homepage_block.id } />
        )
        break
      default:
          // shush error report
      }
    })

    return (
      <div className='homepage-blocks'>
        <TitleBar
          title={ this.props.pageTitle }
          leftButtonLabel={ this.props.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        <h3>
          <Link to='/events' className="event-name">{ this.props.currentUser.current_event_name }</Link>
        </h3>
        <h6 className="event-date">{ this.props.currentUser.current_event_formatted_display_date }</h6>
        <p><Link to='/events'>{ getLabel('switch_event') }</Link></p>
        { blocks }
        <pre className="debug-json">{JSON.stringify(this.state.homepage, false, 2)}</pre>
      </div>
    )
  }
}
